import React, { useEffect, useState } from "react";
import { Box, Button, Divider } from "@mui/material";
import styled from "styled-components";
import axios from "axios";
import CompRgstrdFormSubmitted from "./Modals/CompRgstrdFormSubmitted";
import CompanyInfoSection from "./CompRegFormSections/CompanyInfoSection";
import LegalDocsSection from "./CompRegFormSections/LegalDocsSection";
import BankDetailsSection from "./CompRegFormSections/BankDetailsSection";
import ConsentSection from "./CompRegFormSections/ConsentSection";
import BASE_API_URL from '../apis/index';

const UserCompanyRegistrationForm = ({ initialData, mode = "register", compId }) => {
    const [loading, setLoading] = useState(false);
    const [showRgstrdScsModal, setShowRgstrdScsModal] = useState(false);
    const [fieldValidation, setFieldValidation] = useState({
        companyName: { status: '', message: '' }, // error | success | ''
        gstNumber: { status: '', message: '' }
    });


    const [formData, setFormData] = useState(initialData || {
        companyName: "",
        companyLogo: null,
        companyImages: [],
        countryOfOrigin: null,
        address: "",
        companyTypes: [],
        brief: "",
        countryCode: null,
        mobileInput: "",
        emailInput: "",
        mobileNumbers: [],
        emails: [],

        panNumber: "",
        gstNumber: "",
        cinCode: "",
        // hsnCode: "",
        annualTurnover: "",
        vendorStatus: "",
        vendorType: "",
        cinDoc: null,
        rcDoc: null,
        llpCert: null,
        panDoc: null,
        gstDoc: null,

        accountNumber: "",
        ifsc: "",
        branch: "",
        bank: "",
        accountHolderName: "",
        consent: false,
    });

    useEffect(() => {
        if (initialData) {
            setFormData({ ...initialData });
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value, files, type, checked } = e.target;

        if (name === 'companyName' || name === 'gstNumber') {
            setFieldValidation(prev => ({
                ...prev,
                [name]: { status: '', message: '' }
            }));
        }

        if (type === "file") {
            setFormData({ ...formData, [name]: files[0] });
        } else if (type === "checkbox" && name === "consent") {
            setFormData({ ...formData, consent: checked });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const validateForm = () => {
        if (!formData.companyName.trim()) return "Company Name is required";
        if (!formData.countryOfOrigin) return "Country of Origin is required";
        if (!formData.address.trim()) return "Address is required";

        if (formData.mobileNumbers.length === 0) return "At least one mobile number is required";
        if (formData.emails.length === 0) return "At least one email is required";

        if (!formData.companyLogo && !formData.existingCompanyLogo) return "Company Logo is required";

        if ((formData.companyImages?.length || 0) === 0 && (formData.existingCompanyImages?.length || 0) === 0) return "At least one company image is required";

        if (formData.companyTypes.length === 0) return "Please select at least one company type";
        if (!formData.brief.trim()) return "Brief description is required";

        if (!formData.panNumber.trim()) return "PAN Number is required";
        if (!formData.gstNumber.trim()) return "GST Number is required";
        // if (!formData.cinCode.trim()) return "CIN Code is required";
        // if (!formData.annualTurnover.trim()) return "Annual Turnover is required";
        if (!formData.vendorStatus.trim()) return "Vendor Status is required";
        if (!formData.vendorType.trim()) return "Vendor Type is required";

        // if (!formData.cinDoc) return "CIN Document is required";
        // if (!formData.rcDoc) return "RC Document is required";
        // if (!formData.llpCert) return "LLP Certificate is required";
        if (!formData.panDoc && !formData.existingPanDoc)
            return "PAN Document is required";
        if (!formData.gstDoc && !formData.existingGstDoc)
            return "GST Document is required";

        // if (!formData.accountNumber.trim()) return "Account Number is required";
        // if (!formData.ifsc.trim()) return "IFSC Code is required";
        // if (!formData.branch.trim()) return "Branch is required";
        // if (!formData.bank.trim()) return "Bank name is required";
        // if (!formData.accountHolderName.trim()) return "Account Holder Name is required";

        if (!formData.consent) return "You must agree to the consent checkbox";

        return null; // ✅ Passed validation
    };

    const handleSubmit = async () => {
        const errorMsg = validateForm();
        if (errorMsg) {
            alert(errorMsg);
            return;
        }

        try {
            setLoading(true);
            const authToken = localStorage.getItem("authToken");

            const submissionData = new FormData();
            submissionData.append("companyName", formData.companyName);
            submissionData.append("companyAddress", formData.address);
            submissionData.append("countryOfOrigin", formData.countryOfOrigin?.label || '');
            submissionData.append("companyTypes", JSON.stringify(formData.companyTypes));
            submissionData.append("brief", formData.brief);
            submissionData.append("mobileNumbers", JSON.stringify(formData.mobileNumbers));
            submissionData.append("emails", JSON.stringify(formData.emails));

            submissionData.append("panNumber", formData.panNumber);
            submissionData.append("gstNumber", formData.gstNumber);
            submissionData.append("cinCode", formData.cinCode);
            // submissionData.append("hsnCode", formData.hsnCode);
            submissionData.append("annualTurnover", formData.annualTurnover);
            submissionData.append("vendorStatus", formData.vendorStatus);
            submissionData.append("vendorType", formData.vendorType);

            if (formData.cinDoc) submissionData.append("cinDoc", formData.cinDoc);
            if (formData.rcDoc) submissionData.append("rcDoc", formData.rcDoc);
            if (formData.llpCert) submissionData.append("llpCert", formData.llpCert);
            if (formData.panDoc) submissionData.append("panDoc", formData.panDoc);
            if (formData.gstDoc) submissionData.append("gstDoc", formData.gstDoc);

            if (formData.companyLogo) submissionData.append("companyLogo", formData.companyLogo);
            if (formData.companyImages && formData.companyImages.length > 0) {
                formData.companyImages.forEach((file) => {
                    submissionData.append("companyImages", file);
                });
            }

            submissionData.append("accountNumber", formData.accountNumber);
            submissionData.append("ifsc", formData.ifsc);
            submissionData.append("branch", formData.branch);
            submissionData.append("bank", formData.bank);
            submissionData.append("accountHolderName", formData.accountHolderName);
            submissionData.append("consent", formData.consent);

            // Keep existing logo
            if (formData.existingCompanyLogo) {
                submissionData.append("existingCompanyLogo", formData.existingCompanyLogo);
            }

            // Keep existing images
            if (formData.existingCompanyImages?.length > 0) {
                submissionData.append("existingCompanyImages", JSON.stringify(formData.existingCompanyImages));
            }

            // Keep existing PAN doc
            if (formData.existingPanDoc) {
                submissionData.append("existingPanDoc", formData.existingPanDoc);
            }

            // Keep existing GST doc
            if (formData.existingGstDoc) {
                submissionData.append("existingGstDoc", formData.existingGstDoc);
            }

            if (mode === "edit") {
                // PUT logic for existing company
                // const res = await axios.post(`${BASE_API_URL}/api/user/user-companies/update-company/${compId}`, submissionData, {
                const res = await axios.post(`${BASE_API_URL}/api/seller/company/update/${compId}`, submissionData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                if (res.data.status === "ok") { setShowRgstrdScsModal(true); }
            } else {
                // POST logic for new company
                if (
                    fieldValidation.companyName.status === 'error' ||
                    fieldValidation.gstNumber.status === 'error'
                ) {
                    alert('Please resolve validation errors before submitting');
                    return;
                }

                const res = await axios.post(`${BASE_API_URL}/api/seller/company/register`, submissionData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                if (res.data.status === "ok") { setShowRgstrdScsModal(true); }
            }

        } catch (error) {
            console.error(error);
            alert("Registration failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Wrapper>
            <CompanyInfoSection
                formData={formData}
                setFormData={setFormData}
                handleChange={handleChange}
                fieldValidation={fieldValidation}
                setFieldValidation={setFieldValidation}
            />

            <Divider sx={{ my: 4 }} />

            <LegalDocsSection
                formData={formData}
                setFormData={setFormData}
                handleChange={handleChange}
                fieldValidation={fieldValidation}
                setFieldValidation={setFieldValidation}
            />

            <Divider sx={{ my: 4 }} />

            <BankDetailsSection
                formData={formData}
                handleChange={handleChange}
            />

            <Divider sx={{ my: 4 }} />

            <ConsentSection
                formData={formData}
                handleChange={handleChange}
            />

            <Box className="NavButtonsSec" sx={{ mt: 3 }}>
                <Button size="large" variant="contained" color="warning" onClick={handleSubmit} disabled={loading} className="shadow-none">
                    {loading
                        ? (mode === 'edit' ? "Updating, Please wait" : 'Registering, Please wait')
                        : (mode === 'edit' ? "Update Company" : "Register Company")
                    }
                </Button>
            </Box>

            <CompRgstrdFormSubmitted
                show={showRgstrdScsModal}
                onClose={() => setShowRgstrdScsModal(false)}
                redirectLink={`/user-companies`}
            />
        </Wrapper>
    );
};

export default UserCompanyRegistrationForm;

const Wrapper = styled.form`
    margin: 50px auto;
    padding: 50px;
    background: var(--bg-color);
    border-radius: 12px;

    input[type="file"] {
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .NavButtonsSec {
        button {
            width: 200px;
        }
    }
`;



